import { create } from "zustand";

type CustomerCredentials = {
  identityId?: string;
  accessKeyId?: string;
  secretAccessKey?: string;
  sessionToken?: string;
  expiration?: Date;
};

type BookingDetails = {
  bookingId: string;
  status: string;
  agentId?: string;
  advisorName?: string;
  advisorEmail?: string;
  startAt?: Date;
  endAt?: Date;
  externalId?: string;
};

type CustomerPOAData = {
  phoneNumber: string;
  email: string;
  personalNumber: string;
  transactionId: string;
  validFrom: string;
  validTo: string | null;
  name: string;
  firstName: string;
  lastName: string;
  credentials: CustomerCredentials;
  booking: BookingDetails;
};

type CustomerPOADataStore = {
  customerPOAData: CustomerPOAData;
  updateEmail: (email: string) => void;
  updatePhoneNumber: (phoneNumber: string) => void;
  updatePersonalNumber: (personalNumber: string) => void;
  updateName: (firstName: string, lastName: string) => void;
  updateTransactionId: (transactionId: string) => void;
  updateValidFrom: (date: string) => void;
  updateValidTo: (date: string | null) => void;
  updateCredentials: (credentials: CustomerCredentials) => void;
  updateBooking: (booking: BookingDetails) => void;
};

export const useUpdateCustomerPOAData = create<CustomerPOADataStore>((set) => ({
  customerPOAData: {
    phoneNumber: "",
    email: "",
    personalNumber: "",
    transactionId: "",
    validFrom: "",
    validTo: null,
    name: "",
    firstName: "",
    lastName: "",
    credentials: {},
    booking: {
      bookingId: "",
      status: "",
    },
  },
  updateEmail: (email) =>
    set((state) => ({
      customerPOAData: { ...state.customerPOAData, email: email },
    })),
  updatePhoneNumber: (phoneNumber) =>
    set((state) => ({
      customerPOAData: { ...state.customerPOAData, phoneNumber: phoneNumber },
    })),
  updateName: (firstName, lastName) =>
    set((state) => ({
      customerPOAData: {
        ...state.customerPOAData,
        name: firstName + " " + lastName,
        firstName: firstName,
        lastName: lastName,
      },
    })),
  updatePersonalNumber: (personalNumber) =>
    set((state) => ({
      customerPOAData: {
        ...state.customerPOAData,
        personalNumber: personalNumber,
      },
    })),
  updateTransactionId: (transactionId) =>
    set((state) => ({
      customerPOAData: {
        ...state.customerPOAData,
        transactionId: transactionId,
      },
    })),
  updateValidFrom: (date) =>
    set((state) => ({
      customerPOAData: { ...state.customerPOAData, validFrom: date },
    })),
  updateValidTo: (date) =>
    set((state) => ({
      customerPOAData: { ...state.customerPOAData, validTo: date },
    })),
  updateCredentials: (credentials: CustomerCredentials) =>
    set((state) => ({
      customerPOAData: { ...state.customerPOAData, credentials: credentials },
    })),
  updateBooking: (booking: BookingDetails) =>
    set((state) => ({
      customerPOAData: { ...state.customerPOAData, booking },
    })),
}));
